import React, { useState, useEffect } from 'react'
import OrderSummaryItem from '../order-summary-item/order-summary-item.component.jsx'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { PAYMENT_METHODS } from '../../constants'

class ConfirmedTicketsComponent extends React.Component {
	constructor(props) {
		super(props)
	}
	render() {
		const { isReturn, ticketsGoing, ticketsReturn, paymentMethod } =
			this.props
		const tickets = isReturn ? ticketsReturn : ticketsGoing
		let hasTicketNumber = false
		if (tickets) {
			tickets.map((t) => {
				if (t.ticketNumber) hasTicketNumber = true
			})
		}

		let headers = ['Passageiro', 'Tipo do Documento', 'Número do Documento']

		hasTicketNumber ? headers.push('Bilhete') : null

		if (paymentMethod !== PAYMENT_METHODS.BANKSLIP) {
			headers.push('Localizador')
		}

		function prepareTickects(tickets) {
			const ticketsGroup = {}

			if (tickets) {
				tickets.forEach((ticket) => {
					const { dataPartida } = ticket

					if (!ticketsGroup[dataPartida]) {
						ticketsGroup[dataPartida] = []
					}

					ticketsGroup[dataPartida].push(ticket)
				})
			}

			return Object.values(ticketsGroup)
		}

		var trechosAgrupados = prepareTickects(tickets)

		return this.props.anticipatedPix ? null : (
			<StyledContainer>
				{trechosAgrupados.map((trechos) => {
					const { origem, destino, modalidade, dataPartida, busCompany } =
						trechos[0]
					return (
						<React.Fragment>
							<OrderSummaryItem
								origin={origem}
								destination={destino}
								busSeats={trechos.map((item) => ({
									...item,
									busSeat: item.busSeat || item.poltrona,
									busClass: item.busClass || item.modalidade,
								}))}
								tripGoingSummary={{
									busClass: modalidade,
									departure: dataPartida,
									tripDate: dataPartida,
									busCompany,
								}}
							/>
							<React.Fragment>
								<StyledTable>
									<thead>
										<tr>
											{headers.map((header, index) => (
												<StyledTh key={index}>{header}</StyledTh>
											))}
										</tr>
									</thead>
									{trechos.map((ticket, index) => {
										const {
											documentNumber,
											documentType,
											ticketNumber,
											trackNumber,
											passengerName,
										} = ticket

										return (
											<tbody>
												<tr key={index}>
													<td>{passengerName}</td>
													<td>{documentType.toUpperCase()}</td>
													<td>{documentNumber}</td>
													{paymentMethod ===
													PAYMENT_METHODS.BANKSLIP ? (
														' '
													) : (
														<td>{trackNumber}</td>
													)}
													<td>{ticketNumber}</td>
												</tr>
											</tbody>
										)
									})}
								</StyledTable>
							</React.Fragment>
						</React.Fragment>
					)
				})}
			</StyledContainer>
		)
	}
}

const StyledTh = styled.th`
	padding-right: 15px;
`

const StyledContainer = styled.div`
	overflow: auto;
`

const StyledTable = styled.table`
	border-spacing: 0px 2rem;
	font-size: medium;
	text-align: left;
	padding-left: 5rem;
	width: 100%;
`

const mapStateToProps = (store) => ({
	paymentMethod: store.ticketSale.paymentMethod,
})

const ConfirmedTickets = connect(mapStateToProps)(ConfirmedTicketsComponent)

export default ConfirmedTickets
